import { render, staticRenderFns } from "./BottomSheet.vue?vue&type=template&id=127edabc&scoped=true&"
import script from "./BottomSheet.vue?vue&type=script&lang=js&"
export * from "./BottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheet.vue?vue&type=style&index=0&id=127edabc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127edabc",
  null
  
)

export default component.exports